import { render, staticRenderFns } from "./Teaching.vue?vue&type=template&id=cb3458ca"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"
import style0 from "./Teaching.vue?vue&type=style&index=0&id=cb3458ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports